// patrones
export const regex_dec = /^[0-9]*\.?[0-9]*$/; // acepta números decimales / precios
export const regex_num = /^[0-9\b]+$/; // acepta números enteros
export const regex_no_num = /^([^0-9]*)$/; // NO acepta números
export const regex_two_dec = /^\d+(\.\d{1,2})?$/; // únicamente dos decimales
// correos electrónicos
export const regex_email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
// obtener extensión de archivo
export const regex_file_ext = /(?:\.([^.]+))?$/;